<template>
  <div class="statistic-widget-count-label">
    <h5 class="mb-0 title">Raw Label</h5>
    <Chart :config="chartConfig" class="chart" />
    <ul class="nav">
      <li v-for="(item, index) in data" :key="index" :class="`nav-item ${selected == index ? 'active' : ''}`">
        <a @click.prevent="selected = index" data-toggle="tab" :href="`#tab-${index}`" class="nav-link">{{ item.label }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import Chart from '@/components/Chart.vue'
import solidGauge from 'highcharts/modules/solid-gauge'

export default {
  components: {
    Chart
  },
  data() {
    return {
      selected: 'today'
    }
  },
  computed: {
    chartType() {
      return solidGauge
    },
    data() {
      return this.config?.data
    },
    chartConfig() {
      let options = {
        chart: {
          type: 'solidgauge',
          height: '100%'
        },
        title: {
          text: ''
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        }
      }
      return {
        options: Object.assign(options, this.options(this.data[this.selected] || {})),
        type: this.chartType
      }
    }
  },
  methods: {
    options(item) {
      return {
        subtitle: {
          useHTML: true,
          text: `<p style="font-size:14px;text-align:center;font-weight:bold"><span>Doing</span><br><small>${item.done}/${item.raw + item.done}</small></p>`,
          floating: true,
          verticalAlign: 'middle',
          y: 20
        },
        series: [
          {
            name: item.label,
            data: [
              {
                color: '#2caffe',
                radius: `100%`,
                innerRadius: `75%`,
                y: Math.round((item.done * 10000) / (item.raw + item.done)) / 100
              }
            ]
          }
        ],
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              outerRadius: '100%',
              innerRadius: '75%',
              backgroundColor: '#2caffe4d',
              borderWidth: 0
            }
          ]
        }
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-count-label {
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  height: 100%;
  .nav {
    margin: 5px -15px -15px -15px;
    li {
      flex: 1;
      &:last-child {
        .nav-link {
          border-right: 0;
        }
      }
      &.active {
        .nav-link {
          background: #ffc539;
        }
      }
    }
    .nav-link {
      text-align: center;
      display: block;
      color: #343a40;
      padding: 8% 0;
      background: #ffd87a;
      height: 100%;
    }
  }
  .chart {
    margin: 0 -15px;
  }
}
</style>
